import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import ImageText3 from "../components/ImageText3";
import RichText from "../components/RichText";

import video from "../assets/videos/adblue1.mp4";
import imageurl1 from "../assets/images/adbluesolutions1.png";
import imageurl2 from "../assets/images/adbluesolutions2.png";
import imageurl3 from "../assets/images/adbluesolutions3.png";
import video2 from "../assets/videos/service2.mp4";

function AdblueSolutions() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        Adblue wordt gebruikt bij dieselmotoren om deze schoner te laten rijden.
        De uitstoot van stikstof uit de uitlaat wordt hiermee verminderd. Adblue
        is te vinden in een afzonderlijke tank op vrachtauto’s, (bestel)bussen,
        schepen, landbouwtrekkers en ook personenauto’s met een
        modernedieselmotor.
      </p>
    </>
  );

  const text2 = (
    <>
      <p className="text-white text-lg">
        Bij een storing in het adblue systeem kan het voertuig in het
        noodloopprogramma gaan zitten of het voertuig geeft aan in het dashboard
        dat er nog maar een beperkte afstand kan worden gereden. Dat kan
        komendooreenkapotte adblue pomp, NOXsensorofeenkapotte adblue tank. Het
        vervangen van onderdelen of het repareren ervan kost vaak veel geld en
        de kosten kunnen soms oplopen tot duizenden euro's. Hierbij kan het ook
        voorkomen dat na vervanging van het adblue systeem de storingen op korte
        termijn weer terugkeren. Bij X-TREMETUNINGS bieden wij aan
        omdeadbluevolledig weg te schrijven, dit is een permanente oplossing en
        kostenefficiënt.
      </p>
    </>
  );

  const text3 = (
    <>
      <p className="text-white text-lg">
        Als het adblue systeem is uitgeschakeld zal er een stijging plaatsvinden
        van NOx. Dit zal ervoor zorgen dat u geen last meer heeft van
        vermogensverlies, vervuilde motoronderdelen en/of bijbehorende
        storingen.
      </p>
      <p className="text-white text-lg">
        Meer informatie over NOx? Neem een kijkje bij onze service Lamba & NOx
        delete. Nadezesoftwarematige aanpassing komt uw auto ook nog eens door
        de APK!
      </p>
    </>
  );

  const text4 = (
    <>
      <h3 className="text-[#BD0E0E] text-xl">LET OP!</h3>
      <br />
      <p className="text-white text-lg">
        Deze service is wegens de strenge milieunormen niet toegestaan op de
        openbare weg en is geheel op eigen risico van de klant!
      </p>
    </>
  );
  return (
    <div>
      <HeroVideo1 videoSource={video} heading="ADBLUE SOLUTIONS" />
      <RichText heading="Adblue uitschakelen/ wegschrijven " />
      <ImageText2
        heading="Watis dit?"
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText3
        heading="Wanneer deactiveren?"
        text={text2}
        imageUrl={imageurl2}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <ImageText2
        heading="Wist u dat?"
        text={text3}
        imageUrl={imageurl3}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <RichText text={text4} />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default AdblueSolutions;
